var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const _removeEmptyValueField = (value, name, list) => {
  const updatedList = __spreadProps(__spreadValues({}, list), { [name]: value });
  if (value === void 0) {
    delete updatedList[name];
    return updatedList;
  } else {
    return updatedList;
  }
};
export const useFormDataSetters = (setterFn) => {
  const setInputValue = (name, value) => {
    setterFn == null ? void 0 : setterFn((cl) => {
      const list = _removeEmptyValueField(value, name, cl);
      return __spreadValues({}, list);
    });
  };
  const setMultipleCheckboxValue = (name, value, isChecked) => {
    setterFn == null ? void 0 : setterFn((cl) => {
      const newList = [...cl[name] || []];
      if (isChecked) {
        newList.push(value);
      } else {
        const index = newList.indexOf(value);
        if (index !== -1) {
          newList.splice(index, 1);
        }
      }
      return __spreadProps(__spreadValues({}, cl), {
        [name]: newList
      });
    });
  };
  return { setInputValue, setMultipleCheckboxValue };
};
